import { Visualizer } from ".";
import { HtmlCanvasRenderer } from "../rendering/htmlCanvasRenderer";
import { GREY } from "../puzzles/colors";
const defaultOptions = {
    width: 500,
    height: 500,
    lineWidth: 5,
    arrowColor: GREY,
};
/**
 * Visualize puzzles with canvas
 */
export function Canvas(element, type, options = {}) {
    return new CanvasVisualizer(element, type, options);
}
export class CanvasVisualizer extends Visualizer {
    constructor(element, type, options) {
        options = Object.assign(Object.assign({}, defaultOptions), options);
        if (typeof element === "string") {
            element = document.querySelector(element);
            if (element === null) {
                throw new Error(`Could not find visuzlier element by query selector: ${element}`);
            }
        }
        const renderer = new HtmlCanvasRenderer(options.width, options.height, options.lineWidth, options.arrowColor);
        element.appendChild(renderer.domElement);
        super(renderer, type, options.puzzle);
    }
}
